// extracted by mini-css-extract-plugin
module.exports = {"instantRecsCol":"instantRecsCol--y71ka","loaderWrapper":"loaderWrapper--y71ka"};